import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const IntegrationsGrid = () => {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchIntegrations();
  }, []);

  const fetchIntegrations = async () => {
    try {
      const response = await fetch('/api/integrations');
      if (response.status === 401 || response.status === 403) {
        // Redirect to login if unauthorized
        navigate('/login');
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Fetched integrations:', data);
      setIntegrations(data);
    } catch (error) {
      console.error('Error fetching integrations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleIntegrationClick = (integration) => {
    navigate(`/integrations/${integration.name}`);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Grid container spacing={3} padding={2}>
      {integrations.map((integration) => (
        <Grid item xs={12} sm={6} md={4} key={integration.name}>
          <Card
            onClick={() => handleIntegrationClick(integration)}
            style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
            sx={{
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 8,
              },
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: 2,
              border: '1px solid #e0e0e0',
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Typography 
                  variant="h5" 
                  component="div"
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    fontSize: '1.5rem',
                    color: '#333',
                    mb: 1,
                  }}
                >
                  {integration.name}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default IntegrationsGrid;
